import api from './axiosService';

export const permissionApi = {
    getAll(params = {}) {
        return api.get('/permissions/list', { params });
    },

    getGrouped() {
        return api.get('/permissions/grouped');
    },

    getModules() {
        return api.get('/permissions/modules');
    },

    getById(id) {
        return api.get(`/permissions/${id}`);
    },

    getUsersWithPermissions(params = {}) {
        return api.get('/permissions/users', { params });
    },

    getUserPermissions(userlogId) {
        return api.get(`/permissions/user/${userlogId}`);
    },

    getAvailable() {
        return api.get('/permissions/available');
    },

    check(data) {
        return api.post('/permissions/check', data);
    },

    assign(data) {
        return api.post('/permissions/assign', data);
    },

    revoke(data) {
        return api.post('/permissions/revoke', data);
    },

    sync(userlogId, permissionIds) {
        return api.post('/permissions/sync', {
            userlogId,
            permissionIds,
        });
    },
};